import { SelectOption } from "@components/LSelect";

export const jobTitleOptions = [
    { name: "Office / Admin Services Manager" },
    { name: "Research Coordinator/Assistant" },
    { name: "Physician" },
    { name: "Psychiatrist" },
    { name: "Psychologist" },
    { name: "Testing Coordinator" },
    { name: "Other" }
] as SelectOption[];
